module.exports = __webpack_public_path__ + "static/media/guy.apollo.21ea4ce3.png";